<template>
    <div
        class="item"
        :style="{ width: width + 'px'}"
        @click.stop="clickItem">

        <v-image
            :src="data.picture"
            :style="{
                width: width + 'px',
                height: height + 'px',
                marginBottom: marginBottom + 'px'
            }"
            radius="50%"
        />

        <div
            class="item-name line1"
            :style="{
                fontSize: fontSize + 'px',
                color: color,
            }">{{ data.name }}</div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image'
import VImage from "@/components/image/src/main";
export default {
    name: "starAvatarItem",
    components: {VImage},
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
